import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import ElevvaLogo from "../Mobile/Elements/ElevvaLogo";
import Tooltip from "../ui/Tooltip/Tooltip";
import { instance } from "../../utils/utils";
import "./Sidebar.css";

const Sidebar = ({ isOpen, toggleSidebar, isCollapsed, setIsCollapsed }) => {
    const navigate = useNavigate();
    const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth <= 991);

    // Update screen detection on resize
    useEffect(() => {
        const handleResize = () => {
            setIsMobileScreen(window.innerWidth <= 991);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // On mobile we want the sidebar to ALWAYS be expanded (labels visible)
    const renderExpanded = isMobileScreen ? true : !isCollapsed;

    // Fetch company permissions
    const [accountingPermission, setAccountingPermission] = useState(false);

    useEffect(() => {
        instance.get("memberships/corp/company")
            .then(res => {
                setAccountingPermission(res.data?.accounting_permisson === true);
            })
            .catch(err => console.error("Error fetching permissions:", err));
    }, []);

    const userRole = localStorage.getItem("elevva_role") || "10";
    const menuItems = [
        { path: "/dashboard/home", icon: "bi-house-door-fill", label: "Panel Principal", roles: ["10", "20"] },
        { path: "/dashboard/mob", icon: "bi-layers-fill", label: "Panel Admin", roles: ["10", "20", "30"] },
        { path: "/dashboard/accounting", icon: "bi-currency-dollar", label: "Contabilidad", roles: ["10", "20"], isPro: true },
        { path: "/dashboard/athletes-management", icon: "bi-people-fill", label: "Gestión de Atletas", roles: ["10", "20", "30"] },
        { path: "/dashboard/graphics", icon: "bi-bar-chart-fill", label: "Gráficas", roles: ["10", "20", "30"] },
        { path: "/dashboard/notifications", icon: "bi-bell-fill", label: "Notificaciones", roles: ["10", "20"] },
    ].filter(item => item.roles.includes(userRole));

    const handleLogout = () => {
        localStorage.clear();
        navigate("/");
    };

    return (
        <aside className="premium-sidebar-container">
            <div className="sidebar-header">
                <div className="sidebar-logo-area">
                    <a href="/dashboard/home" target="_blank" rel="noopener noreferrer" className="sidebar-logo-link">
                        <ElevvaLogo fill="white" collapsed={isMobileScreen ? false : isCollapsed} />
                    </a>
                </div>

                <button className="sidebar-close-btn d-lg-none" onClick={toggleSidebar}>
                    <i className="bi bi-x-lg" style={{ color: 'white' }}></i>
                </button>
            </div>

            <nav className="sidebar-nav">
                {renderExpanded && <div className="sidebar-section-label">PRINCIPAL</div>}
                {menuItems.map((item) => (
                    <Tooltip key={item.path} text={!renderExpanded ? item.label : ""} position="right">
                        <NavLink
                            to={item.path}
                            className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
                        >
                            <div className="sidebar-link-icon">
                                <i className={`bi ${item.icon}`}></i>
                                {!renderExpanded && item.isPro && (
                                    <span className="pro-badge pro-badge-collapsed">
                                        <i className="bi bi-star-fill" style={{ fontSize: '10px', lineHeight: 1 }}></i>
                                    </span>
                                )}
                            </div>
                            {renderExpanded && (
                                <span className="sidebar-link-text">
                                    {item.label}
                                    {item.isPro && <span className="pro-badge ms-2">PLUS</span>}
                                </span>
                            )}
                        </NavLink>
                    </Tooltip>
                ))}
            </nav>

            <div className="sidebar-footer">
                <div className="sidebar-divider"></div>

                <Tooltip text={!renderExpanded ? "Preguntas Frecuentes" : ""} position="right">
                    <a href="https://elevva.com.co/faq/" target="_blank" rel="noopener noreferrer" className="sidebar-link mb-2" style={{ textDecoration: 'none' }}>
                        <div className="sidebar-link-icon">
                            <i className="bi bi-question-circle"></i>
                        </div>
                        {renderExpanded && <span className="sidebar-link-text">Ayuda / FAQ</span>}
                    </a>
                </Tooltip>

                {/* DEPRECATION: Remove this Entire NavLink for "Versión Clásica" when legacy is gone */}
                {(userRole === "10" || userRole === "20" || userRole === "30") && (
                    <Tooltip text={!renderExpanded ? "Versión Clásica" : ""} position="right">
                        <NavLink to="/admin" className="sidebar-link toggle-version-btn mb-2">
                            <div className="sidebar-link-icon">
                                <i className="bi bi-arrow-left-right"></i>
                            </div>
                            {renderExpanded && <span className="sidebar-link-text">Versión Clásica</span>}
                        </NavLink>
                    </Tooltip>
                )}

                <Tooltip text={!renderExpanded ? "Cerrar Sesión" : ""} position="right">
                    <button className="sidebar-logout-btn" onClick={handleLogout}>
                        <div className="sidebar-link-icon logout">
                            <i className="bi bi-box-arrow-right"></i>
                        </div>
                        {renderExpanded && <span className="sidebar-link-text">Cerrar Sesión</span>}
                    </button>
                </Tooltip>
            </div>
        </aside>
    );
};

export default Sidebar;
